module.exports = __webpack_public_path__ + "img/ruffle back width.7fc1c83b.png";